// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"875af89e","171":"333607d6","374":"ecb59096","453":"7a54251b","466":"3a958dc4","507":"60d8e639","801":"6475b798","903":"f4481253"}[chunkId] + ".chunk.js";
};